import { AxiosError } from 'axios';
import { get } from '@/utils';
import { IAnnouncementStatus, IAnnouncementStatusesResponse } from './types';

// GET api/announcement-statuses → lista de statusuri (nomenclator mic, îl cerem integral).
async function fetchAnnouncementStatuses(): Promise<IAnnouncementStatus[]> {
	try {
		const res = await get('api/announcement-statuses?PageNumber=1&PageSize=500');
		const data = res.data as IAnnouncementStatusesResponse | IAnnouncementStatus[];
		return Array.isArray(data) ? data : data.items ?? [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să accesăm statusurile anunțurilor.');
	}
}

export { fetchAnnouncementStatuses };
